module.exports = __webpack_public_path__ + "fonts/CCBackBeatLight.b5543d4.woff2";